import * as React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
    data: any;
    divider?: boolean;
}

class MainItemComp extends React.Component<IProps, any> {
    public render() {
        const props = this.props;
        return (
            <li className={`flex main-item ${props.divider ? 'divider' : ''}`}>
                <Link to={`/news/${props.data.id}`} className="main-iteml">
                    <img src={props.data.picUrl}/>
                </Link>
                <div className="flex-c main-itemr">
                    <Link to={`/news/${props.data.id}`}>
                        <strong className="text-overflow">{props.data.articleName}</strong>
                    </Link>
                    <p>
                        {
                           props.data.labelList ? props.data.labelList.map((v: any, k: number) => {
                                return (
                                    <Link to={`/listPage/${v.labelNum}?name=${encodeURIComponent(v.lbelName)}`} key={`labelItem${v.id}`}>{v.lbelName}</Link>
                                )
                           }) : null
                        }
                        <span>{props.data.timeStr}</span>
                    </p>
                </div>
            </li>
        );
    }
}

export default MainItemComp;


// WEBPACK FOOTER //
// ./src/components/main/item.tsx